import { Stack, Typography } from "@mui/material"
import useLanguage from "../../hooks/use_language"

const DiseaseCode = ({ icd10 }) => {
  const { language } = useLanguage()

  return (
    <Stack direction="row" spacing={1}>
      <Typography variant="caption">{language === "ru" ? "МКБ-10" : "ICD-10"}</Typography>
      <Typography variant="caption" sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>
        {icd10}
      </Typography>
    </Stack>
  )
}

export default DiseaseCode
